import React from "react";
import VoiceApiComponent from "../../site/VoiceApiComponent";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../../Dashboard/DashboardLeftMenu";
const VoiceApiDashboard = () => {
  return (
    <div className="wrapper">
      <DashboardLeftMenu />
      <div className="main">
        <DashboardHeader />
        <main className="content">
          <div className="container-fluid p-0">
            <div className=" row mb-2 mb-xl-3">
              <div className="col-auto d-none d-sm-block">
                <h3>
                  <strong> Voice Docs</strong>
                </h3>
              </div>
            </div>
            <div className="">
              <div className="card">
                <div className="card-body">
                  <h3 className="mt-1 main_innerheading">Voice API</h3>
                  <VoiceApiComponent />
                </div>
              </div>
            </div>
          </div>
        </main>
        <DashboardFooter />
      </div>
    </div>
  );
};

export default VoiceApiDashboard;
